export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reimposta"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleziona tutto"])}
}